import script from "./TestimonialsSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./TestimonialsSection.vue?vue&type=script&lang=ts&setup=true"

import "./TestimonialsSection.vue?vue&type=style&index=0&id=45d360c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45d360c1"]])

export default __exports__